import {$t} from "@/i18n";


export const CALENDAR_STATUS = {
    APPROVED: 'approved',
    REJECTED: 'declined',
    DONE: 'done',
    IN_REVIEW: 'in_review'
}

export const LOCKED_CALENDAR_STATUSES = [
    CALENDAR_STATUS.APPROVED,
    CALENDAR_STATUS.DONE
]

export const CALENDAR_TYPE = {
    VACATION: 'vacation',
    FLEXTIME_VACATION: 'flextime_vacation',
    AWAY: 'away',
    SICK_LEAVE: 'sick_leave',
    PARENTAL_LEAVE: 'parental_leave'
}

export const VACATION_CALENDAR_TYPE = {
    VACATION: 'vacation',
    FLEXTIME_VACATION: 'flextime_vacation',
    AWAY: 'away',
    SICK_LEAVE: 'sick_leave',
    PARENTAL_LEAVE: 'parental_leave',
    COMPANY_FREE_TIME: 'company_free_time'
}

export const getEventIconData = (eventType) => {
    if (['contact_birthday', 'member_birthday'].includes(eventType)) {
        return {
            color: 'pink',
            icon: 'Cake'
        }
    } else if (eventType === 'company_event') {
        return {
            color: 'royal-blue',
            icon: 'Megaphone'
        }
    } else if (eventType === VACATION_CALENDAR_TYPE.VACATION) {
        return {
            color: 'brown',
            icon: 'Palmtree'
        }
    } else if (eventType === VACATION_CALENDAR_TYPE.FLEXTIME_VACATION) {
        return {
            color: 'brown',
            icon: 'Clock'
        }
    } else if (eventType === VACATION_CALENDAR_TYPE.SICK_LEAVE) {
        return {
            color: 'brown',
            icon: 'Frown'
        }
    } else if (eventType === VACATION_CALENDAR_TYPE.PARENTAL_LEAVE) {
        return {
            color: 'brown',
            icon: 'Baby'
        }
    } else if (Object.values(VACATION_CALENDAR_TYPE).includes(eventType)) {
        return {
            color: 'brown',
            icon: 'Footprints'
        }
    } else if (eventType === 'article') {
        return {
            color: 'n4',
            icon: 'AlignLeft'
        }
    } else if (eventType === 'article') {
        return {
            color: 'n4',
            icon: 'GraduationCap'
        }
    }

    return null
}

export const translateCalendarType = (type) => {
    if (type === CALENDAR_TYPE.VACATION) {
        return $t('Vacation')
    } else if (type === CALENDAR_TYPE.FLEXTIME_VACATION) {
        return $t('Flextime bonus')
    } else if (type === CALENDAR_TYPE.AWAY) {
        return $t('away_type_Away')
    } else if (type === CALENDAR_TYPE.SICK_LEAVE) {
        return $t('Sick leave')
    } else if (type === CALENDAR_TYPE.PARENTAL_LEAVE) {
        return $t('Parental leave')
    }

    return type
}

export default {
    CALENDAR_TYPE,
    CALENDAR_STATUS,
    LOCKED_CALENDAR_STATUSES,
    translateCalendarType
}